/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Passkey_RenameInputs */

const en_passkey_rename = /** @type {(inputs: Passkey_RenameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rename ${i?.name}`)
};

const de_passkey_rename = /** @type {(inputs: Passkey_RenameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} umbenennen`)
};

/**
* | output |
* | --- |
* | "Rename {name}" |
*
* @param {Passkey_RenameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkey_rename = /** @type {((inputs: Passkey_RenameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_RenameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkey_rename(inputs)
	return en_passkey_rename(inputs)
});